<template lang="pug">
  .product-container
    .product-header
      .product-title {{ $t('好快活 营销行业人才平台') }}
      .product-desc 好快活是一个营销人才平台，以社群+公众号+小程序结合的运营模式展开，
      .product-desc 帮助企业客户连接并匹配充满才华的营销人才。
      //- .product-desc 目前已为阳狮广告、GroupM等知名4A公司提供服务与支持。
      el-button.product-link(
        @click="onApplyAccount"
      ) {{ $t('咨询合作') }}
      .product-img
        img(
          src="@/assets/happy-1.png"
        )
        //- img(
        //-   src="@/assets/bid_agent-1.png"
        //- )
    .product-content-container
      .product-happy-item
        .product-happy-item-thumb
          img(src="@/assets/happy_product_item.png", alt="alt")
        .product-happy-item-desc
          .happy-item-desc
            .desc-title
              span.title 好快活
              span.line 
              span.title 名人榜
            .desc-production
              .title
                img(src="@/assets/libra-icon.png", alt="alt")
                span 人才库
              .pro-desc 平台垂直于营销行业，覆盖各类职位需求，包括创意策划、设计、文案、摄影等众多优秀人才。营销企业可自行在人才库中寻找合适的人才，也可以获得点对点推荐和一对一服务。
            .desc-production
              .title
                img(src="@/assets/libra-icon.png", alt="alt")
                span 个人IP塑造
              .pro-desc 平台帮助营销行业freelancer打造自己的专属主页，进行明星人才包装。同时有平台官方背书，数字获客工具，多渠道流量推送，助力freelancer才华展示。
      .product-happy-item
        .product-happy-item-thumb
          img(src="@/assets/happy_product_item-1.png", alt="alt")
        .product-happy-item-desc
          .happy-item-desc
            .desc-title
              span.title 好快活
              span.line 
              span.title 人才情报局
            .desc-production
              .title
                img(src="@/assets/libra-icon.png", alt="alt")
                span 领域垂直
              .pro-desc 拥有庞大的人才简历库，一站式触达2w+营销人才，涵盖设计、文案、策略/策划等众多职位。
            .desc-production
              .title
                img(src="@/assets/libra-icon.png", alt="alt")
                span 专业服务
              .pro-desc 平台免费初筛简历，为HR节省大量时间，确保每一份到手简历真实高质量。
            .desc-production
              .title
                img(src="@/assets/libra-icon.png", alt="alt")
                span 增值服务
              .pro-desc 可随时咨询职位动态，反馈职位阅读情况，提出专业建议。
            .desc-production
              .title
                img(src="@/assets/libra-icon.png", alt="alt")
                span 全面便捷
              .pro-desc 兼职&全职职位均可发布，一键生成职位海报，多渠道快捷转发。
      //- .product-happy-item(style='display: flex;justify-content: space-between;')
      //-   .product-happy-item-thumb
      //-     img(src="@/assets/happy_product_item-2.png",  alt="alt")
      //-   .product-happy-item-desc
      //-     .happy-item-desc
      //-       .desc-title
      //-         span.title(style="margin-left:0") 好快活
      //-         span.line 
      //-         span.title 轻轻付
      //-       .desc-production
      //-         .title
      //-           img(src="@/assets/libra-icon.png", alt="alt" )
      //-           span 0风险成本低
      //-         .pro-desc 轻轻付平台具有官方颁发的委托代征资质，可以合法合规给自由职业者结算费用，全国布局，有效降低成本90%以上。
      //-         .pro-desc 只服务营销行业，确保100%真实场景，同时对甲方来说轻松实现四流（业务、资金、合同、票据）合一，安全高效。
      //-       .desc-production
      //-         .title
      //-           img(src="@/assets/libra-icon.png", alt="alt")
      //-           span 稳定高效
      //-         .pro-desc 365*24小时，SaaS平台操作，稳定通畅。农行专用监管账户，资金随时可查。当天到账当天支付，钱不过夜。
      //-         .pro-desc 手机网签，批量支付，合并结算，省时高效。专业客服一对一服务，及时解决流程中遇到的任何问题。
      //-       .desc-production
      //-         .title
      //-           img(src="@/assets/libra-icon.png", alt="alt")
      //-           span 专家服务
      //-         .pro-desc 专注服务于广告营销行业，并聘请专业律师团队进行风控审核，让企业和自由职业者用得放心。
      //-         .pro-desc 更有人资、银行、税务专家驻场，随时咨询。
      //-       .desc-production
      //-         .title
      //-           img(src="@/assets/libra-icon.png", alt="alt")
      //-           span 隐私保护
      //-         .pro-desc 执行最高商用等级的隐私数据保护体系，确保个人自然信息和交易信息的完全脱敏与零泄露。          

    //- section#clients-say
    //-   div.clients-say__content
    //-     img(
    //-       alt="what our clients say"
    //-       src="@/assets/clients-say-logo.png"
    //-     )
    //-     div
    //-       ul.clients-say__case__content(style="height: 150px")
    //-         li(:class="{'active': activeIndex === 0}")
    //-           p {{ $t('使用Bid Agent已经有超过两年的时间，软件的不断完善是有目共睹的，BA团队一直在坚持聆听客户的声音，并能快速响应，将我们的很多建议变成现实功能。通过BA的锁定排名功能，在很大程度上确保了关键词排名，自动报告功能节省了工作时间，提高了工作效率。其他功能，也是从业务出发而打造的，真正在乎用户体验。') }}
    //-         li(:class="{'active': activeIndex === 1}")
    //-           p {{ $t("Bid Agent是个强大的优化系统，能够集合各搜索引擎于一体，最大限度帮助客户节约成本，提高投入产出比，一站式解决搜索的全程优化。更能提供高逼格的可视化报告，定制专属于客户的模板。") }}
    //-         li(:class="{'active': activeIndex === 2}")
    //-           p {{ $t("使用BA 5年，BA帮助我们便捷管理跨搜索引擎的多个后台，并生成定制化报告，有效提升大体量账户投放效率；近几年随着平台功能进化，竞争对手监测的功能弥补了市场的空白，帮助我们洞察竞争对手市场动作；但复歌团队仍然不断挑战，2017年推出的反作弊功能，又一次走在了市场前列，规避投放中的问题流量，帮助广告主代理商进行更有效的投放。为此，衷心感谢多年来复歌的合作伙伴的努力和支持！") }}
    //-       ul.clients-say__case__avators.f.f-sa
    //-         li(
    //-           :class="{'active_li': activeIndex === 0}"
    //-           @mouseover="activeIndex = 0"
    //-         )
    //-           div
    //-             img(
    //-               alt="avator"
    //-               src="@/assets/elvis-xu.jpg"
    //-             )
    //-           p
    //-             | Elvis Xu
    //-             br
    //-             span
    //-               | Managing Director, Search
    //-               br
    //-               | GroupM
    //-         li(
    //-           @mouseover="activeIndex = 1"
    //-           :class="{'active_li': activeIndex === 1}"
    //-         )
    //-           div
    //-             img(
    //-               alt="avator"
    //-               src="@/assets/wenya-li.jpg"
    //-             )
    //-           p
    //-             | Wenya Li
    //-             br
    //-             span
    //-               | Head of Ecselis
    //-               br
    //-               | Havas
    //-         li(
    //-           @mouseover="activeIndex = 2"
    //-           :class="{'active_li': activeIndex === 2}"
    //-         )
    //-           div
    //-             img(
    //-               alt="avator"
    //-               src="@/assets/zoe.png"
    //-             )
    //-           p
    //-             | Zoe
    //-             br
    //-             span
    //-               | Head of Performance
    //-               br
    //-               | OMP

    Contact
</template>

<script>
import PageFooter from '@/components/MobilePageFooter'
import Contact from '@/components/MobileContact'
export default {
  components: {
    PageFooter,
    Contact
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  methods: {
    onApplyAccount () {
      this.$router.push('/contact?redirectUrl=/product/happy&buttonName=好快活')
    }
  }
}
</script>
<style lang="stylus" scoped>
.product-header
  // height: 640px!important
.product-content-container
  // margin-top: 1107px!important
  .product-happy-item
    width 100%
    margin: auto
    display: flex
    flex-direction: column
    margin-bottom: 34px
    .product-happy-item-thumb
      // width: 50%
      img
        width: 100%
        display: block
        margin: auto
    .product-happy-item-desc
      // width: 100%
      padding 0 16px
      .happy-item-desc
        margin-top: 40px
        .desc-title
          margin-bottom: 22px
          font-family: PingFang SC;
          font-style: normal;
          font-weight: 300;
          font-size: 32px;
          line-height: 59px;
          color: #303251;
          display: flex
          align-items: center
          .line
            width: 1px
            height: 30px
            background: #303251
            display:inline-block
          .title
            margin-right: 10px
            &:last-of-type
              margin-right: 0
              margin-left: 10px
        .desc-production
          margin-bottom: 24px
          .title
            display: flex
            align-items: center
            margin-bottom: 15px
            img 
              width: 12px
              margin-right: 12px
            span
              font-family: PingFang SC;
              font-style: normal;
              font-weight: 600;
              font-size: 22px;
              line-height: 31px;
              /* identical to box height */
              color: rgba(48, 50, 81, 0.697689);
          .pro-desc
            font-family: PingFang SC;
            font-style: normal;
            font-weight: normal;
            font-size: 22px;
            line-height: 33px;
            padding-left: 24px
            margin-bottom: 10px
            text-align: justify
            &:last-of-type
              margin-bottom: 0
            color: rgba(48, 50, 81, 0.697689);
    // &:nth-child(even)
    //   flex-direction: row-reverse;       
</style>
